import React from 'react'
import "./List.css"
import { useRef,useState} from 'react';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { ListItem } from '../ListItem/ListItem';
export const List = () => {
  const [isMoved, setisMoved] = useState(false);
  
  const [slideNumber, setslideNumber] = useState(0);
  const listRef = useRef()
  const handleoption=(direction)=>{
    setisMoved(true);
    let distance = listRef.current.getBoundingClientRect().x - 50;
    if(direction === "left" && slideNumber > 0){
    
      setslideNumber(slideNumber-1);
      listRef.current.style.transform = `translateX(${230+distance}px)`
      console.log(distance);
      
    } if(direction === "right" && slideNumber < 5){
      setslideNumber(slideNumber + 1);
      listRef.current.style.transform = `translateX(${-230+distance}px)`
      console.log(distance);
  
    }
  }
  return (
    <div className='list'>
    <span className="listHeader">Continue to watch</span>
    <div className="wrapper">
    <ArrowBackIosNewOutlinedIcon 
     className="arrowbtn left" 
     onClick={()=> (handleoption("left"))} 
     style={{display: !isMoved && 'none'}}/>
   <div className="container" ref={listRef}>
    <ListItem index={0}/>
    <ListItem index={1}/>
    <ListItem index={2}/>
    <ListItem index={3}/>
    <ListItem index={4}/>
    <ListItem index={5}/>
    <ListItem index={6}/>
    <ListItem index={7}/>
    <ListItem index={8}/>
    <ListItem index={9}/>
   </div>
    <ArrowForwardIosOutlinedIcon className="arrowbtn right" onClick={()=> (handleoption("right"))}/>
    </div>
    </div>
  )
}
